import type { QueryClient } from '@tanstack/react-query';

const CONFIGURATION_CHANGED_EVENT = 'sacon:broadcast-configuration-changed';
const QUERY_KEYS = ['alarm-broadcast-options', 'alarm-broadcast-recording-targets', 'admin-v2-device-options', 'admin-v2-devices', 'admin-v2-product-models'];

function browserTarget() {
  return typeof window === 'undefined' ? undefined : window;
}

/** 전역 현장 구독은 화면별 QueryClientProvider보다 위에 있으므로 변경 알림만 전달합니다. */
export function notifyBroadcastConfigurationChanged(target: EventTarget | undefined = browserTarget()) {
  target?.dispatchEvent(new Event(CONFIGURATION_CHANGED_EVENT));
}

/** 관리자·보드·지도는 각 화면이 실제 사용하는 캐시를 갱신하고 종료 시 구독을 해제합니다. */
export function subscribeBroadcastCacheInvalidation(client: Pick<QueryClient, 'invalidateQueries'>, target: EventTarget | undefined = browserTarget()) {
  const invalidate = () => {
    for (const key of QUERY_KEYS) {
      void client.invalidateQueries({ queryKey: [key] }).catch(() => {
        // 조회 오류는 각 화면에서 처리하며 로그에는 인증값이나 서버 응답을 포함하지 않습니다.
        console.warn('방송 설정 변경 후 목록 갱신에 실패했습니다.');
      });
    }
  };
  target?.addEventListener(CONFIGURATION_CHANGED_EVENT, invalidate);
  return () => target?.removeEventListener(CONFIGURATION_CHANGED_EVENT, invalidate);
}
